import axios from "axios";
import {
    VILLA_MAP_PLACE_QUERY_AUTOCOMPLETE_ENDPOINT,
    VILLA_MAP_GEOCODE_ENDPOINT,
    VILLA_MAP_PLACE_DETAIL_ENDPOINT,
} from "@/api/map";
import { IGoogleMapRepository } from "./googlemap.types";

export class GoogleMapRepository implements IGoogleMapRepository {
    async getPlaceList(input: string, location: string, radius: string, language: string): Promise<any> {
        return (
            await axios.get(
                VILLA_MAP_PLACE_QUERY_AUTOCOMPLETE_ENDPOINT +
                `?input=${input}&center=${location}&radius=${radius}&language=${language}`
            )
        ).data?.predictions;
    }
    async getDetails(placeId: string, fields: string[]): Promise<any> {
        const { result } = (
            await axios.get(
                VILLA_MAP_PLACE_DETAIL_ENDPOINT +
                `?place_id=${placeId}&fields=${String(fields)}`
            )
        ).data;
        return result;
    }
    async geocode(location: string): Promise<any> {
        const { results } = (
            await axios.get(VILLA_MAP_GEOCODE_ENDPOINT + `?address=${location}`)
        ).data;

        return results;
    }

}
